import * as React from 'react'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  toggle: (value: boolean) => () => void
  open: boolean
}

const FilterSelect = ({ toggle, open }: Props) => {
  return (
    <Box
      onClick={toggle(true)}
      flexDirection="row"
      alignItems="center"
      width="s120"
      justifyContent="spaceBetween"
      background="grey000White"
      border={{
        all: {
          width: 's2',
          style: 'solid',
          color: 'grey400',
        },
      }}
      borderRadius={{
        all: 'abs008',
      }}
      paddingRight="s12"
      paddingLeft="s16"
      height="full"
    >
      <Text size="300">{i18n.t('surveys.index.table.filter')}</Text>
      <Icon.Small icon={open ? 'caret-up' : 'caret-down'} />
    </Box>
  )
}

export default FilterSelect
